import React, { createContext, useState, useContext, useCallback } from 'react';
import { useAuth } from '../hooks/useAuth'; // useAuth をインポート
import { db } from '../firebase'; // firebase から db をインポート
import { doc, updateDoc } from 'firebase/firestore'; // Firestore の操作関数をインポート

const TutorialContext = createContext();

export const useTutorial = () => useContext(TutorialContext);

export const TutorialProvider = ({ children }) => {
  const { user, updateUserContext } = useAuth(); // useAuth から user と updateUserContext を取得
  const [isTutorialActive, setIsTutorialActive] = useState(false);
  const [tutorialStep, setTutorialStep] = useState(0);

  const startTutorial = useCallback(() => {
    setTutorialStep(0);
    setIsTutorialActive(true);
  }, []);

  const stopTutorial = useCallback(async () => { // async に変更
    setIsTutorialActive(false);
    setTutorialStep(0);
    // チュートリアル完了フラグをユーザーデータに書き込む
    if (user && !user.isAnonymous) { // 匿名ユーザーではない場合のみ
      const userRef = doc(db, 'users', user.uid);
      try {
        await updateDoc(userRef, {
          tutorial_completed: true,
        });
        updateUserContext({ tutorial_completed: true }); // Contextも更新
      } catch (error) {
        console.error("チュートリアル完了フラグの更新に失敗しました:", error);
      }
    }
  }, [user, updateUserContext]); // user と updateUserContext を依存配列に追加

  const goToStep = useCallback((step) => {
    setTutorialStep(step);
  }, []);

  const nextStep = useCallback(() => {
    setTutorialStep(prev => prev + 1);
  }, []);

  const value = {
    isTutorialActive,
    tutorialStep,
    startTutorial,
    stopTutorial,
    goToStep,
    nextStep,
  };

  return (
    <TutorialContext.Provider value={value}>
      {children}
    </TutorialContext.Provider>
  );
};
